import { render, staticRenderFns } from "./bossOs.vue?vue&type=template&id=3d354065"
import script from "./bossOs.vue?vue&type=script&lang=js"
export * from "./bossOs.vue?vue&type=script&lang=js"
import style0 from "./bossOs.vue?vue&type=style&index=0&id=3d354065&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports